<template>
  <div>
    <el-table :data="tableData" empty-text="该商品暂未关联到有关产品">
      <el-table-column :show-overflow-tooltip='true' label="产品编码" prop="productCode"></el-table-column>
      <el-table-column :show-overflow-tooltip='true' label="产品名称" prop="productName"></el-table-column>
      <el-table-column label="基础零售价" prop="retailPrice"></el-table-column>
      <!-- <el-table-column label="清仓基础零售价" prop="clearanceRetailPrice"></el-table-column> -->
    </el-table>
  </div>
</template>

<script>
export default {
  props: ['row'],
  data() {
    return {
      tableData: []
    }
  },
  mounted() {
    this.init();
  },
  methods: {
    init() {
      let params = {
        goodsCode: this.row.goodsCode
      }
      this.$q.goods.getProductByGoodsCode({params})
      .then(res=>{
        if(res.code == '200') {
          this.tableData = res.data;
        }
      })
    }
  }
}
</script>

<style lang="stylus" scoped>

</style>